import { Table } from "antd";
import React, {useState,useEffect} from "react";
import { Link } from "react-router-dom";

import Select from "react-select";
import AssetTable from "components/Tables/Assets";

export const EmployeeAssets = ({userData}) => {

  return (
    <>
   

        {/* /Assests Tab */}
        <div className="tab-pane fade" id="emp_assets">
            <AssetTable userData={userData}/>
        </div>
        {/* /Bank Tab */}

      
    </>
  );
};
